import React, { Component } from 'react';
import PropTypes from 'prop-types';

import MetaTags from 'react-meta-tags';

import { Background } from 'C4';

export default class FileViewer extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    document.body.classList.add('no-scroll', 'fileViewer');
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll fileViewer');
  }

  render() {
    const {
      location: { search },
    } = this.props;

    const {
      groups: { appId, path },
    } = /(?<appId>[0-9]{3})(?<path>.*?)$/g.exec(search.slice(1)) || { groups: {} };

    const url =
      +appId >= 500
        ? `https://front.travpromobile.com/${appId || window.appId}${path}`
        : `https://travpro.yourworldapps.nl/apptool/app/${appId || window.appId}${path}`;

    return (
      <div data-fancybox="viewer" data-options={JSON.stringify({ modal: true })} href={url}>
        <MetaTags>
          <title>{'Sharing title'}</title>
          <meta name="description" content="sharing description" />
          <meta property="og:title" content="MyApp" />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:image" content={url} />
        </MetaTags>
        <Background type="image" background="https://cdn.travpromobile.com/apptool/app/114/salesCompanion/bg.jpg" />
      </div>
    );
  }
}

FileViewer.propTypes = {
  location: PropTypes.shape().isRequired,
};
